import PrimaryButton from "@/components/common/buttons/primary-button/PrimaryButton";
import styles from "./access-denied-page.module.scss";
import { useTranslation } from "react-i18next";
import { LOGIN_ROUTE } from "@/routing/app-routes";
import { useNavigate } from "react-router-dom";

const AccessDenied = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <div className={`${styles.accessDeniedPage} flex center align-center`}>
      <div
        className={`${styles.messageContainer} flex column center align-center`}
      >
        <div className={`${styles.primaryMessage} mb-2`}>
          {t("accessDenied")}
        </div>
        <div className={`${styles.secondaryMessage} mb-8`}>
          {t("tryLoggingInAgain")}
        </div>
        <div className="one-quarter">
          <PrimaryButton
            onClick={() => navigate(LOGIN_ROUTE)}
            text={t("goToLoginPage")}
          />
        </div>
      </div>
    </div>
  );
};

export default AccessDenied;
